import { VisiblePrescriptionStatus as VisiblePrescriptionStatusKind } from "common/types/prescriptions";

import Status from "client/common/components/content/Status";

import { getPrescriptionStatusDisplay } from "../utils";

type PrescriptionStatusProps = {
  prescription: { visible_status: VisiblePrescriptionStatusKind };
};

const PrescriptionStatus = ({ prescription }: PrescriptionStatusProps) => {
  const { color, label } = getPrescriptionStatusDisplay(prescription.visible_status);
  return <Status color={color}>{label}</Status>;
};

export default PrescriptionStatus;
